export default "__VITE_ASSET__DrwBaVql__"